import markDeclares from "./markDeclares";
import markDeclareReturn from "./markDeclareReturn";


const markDeclareService = [{
    matcher: 'processingMarkDeclare',
    reply: config => {
        return [200, markDeclares]
    }
},{
    matcher: /processingMarkDeclare\/(.*)/,
    reply: config => {
        const id = /processingMarkDeclare\/(.*)/.exec(config.url)[1];
        const data = markDeclares.find(app => app.id === id);
        return [200, data];
    }
},{
    matcher: 'processingMarkDeclareReturn',
    reply: config => {
        return [200, markDeclareReturn];
    }
},{
    matcher: /processingMarkDeclareReturn\/(.*)/,
    reply: config => {
        const id = /processingMarkDeclareReturn\/(.*)/.exec(config.url)[1];
        const data = markDeclareReturn.find(app => app.id === id);
        return [200, data];
    }
}]

export default markDeclareService